// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/vanStaenWhiteClose.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/vanStaenWhiteOpen.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome__container {
  --backgroundWhiteClose: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --backgroundWhiteOpen: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.welcome__container .welcome__welcome {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: 100vw;
  top: 0;
  left: 0;
  position: absolute;
}
.welcome__container .welcome__welcome .welcome__openeyes {
  position: absolute;
  margin-top: -75px;
  margin-right: -20px;
  width: min(450px, 50vw);
  height: min(150px, 20vh);
  border: 1px solid transparent;
}
@media all and (max-width: 670px) {
  .welcome__container .welcome__welcome .welcome__openeyes {
    bottom: 200px;
  }
}
.welcome__container .welcome__background {
  position: absolute;
  z-index: 0;
  width: 100vw;
  background-image: var(--backgroundWhiteClose);
  background-color: cyan;
  background-blend-mode: lighten;
  background-attachment: fixed;
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  transition: background-image 0.2s ease-in-out;
  top: 0;
  left: 0;
}
.welcome__container .welcome__background:after {
  content: '';
  position: absolute;
  display: block;
  width: 100vw;
  height: 100%;
  z-index: 1;
  padding-left: 7px;
  background-image: var(--backgroundWhiteClose);
  background-color: red;
  background-blend-mode: lighten;
  background-size: cover;
  mix-blend-mode: darken;
  background-attachment: fixed;
  background-position: bottom;
  background-repeat: no-repeat;
  transition: background-image 0.2s ease-in-out;
}
@keyframes stack {
  0% {
    margin-left: 15px;
  }
  3% {
    margin-left: -5px;
  }
  4% {
    background-image: var(--backgroundWhiteOpen);
  }
  6% {
    margin-left: 5px;
  }
  10%,
  100% {
    margin-left: 5px;
    background-image: var(--backgroundWhiteClose);
  }
}
.welcome__container .welcome__loader {
  position: absolute;
  z-index: 0;
  width: 100vw;
  background-color: white;
  top: 0;
  left: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 3px;
}
.welcome__container .welcome__loader .welcome__imageLoading {
  color: rgba(33, 33, 33, 0.25);
  font-size: 52px;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/Welcome.less"],"names":[],"mappings":"AAAA;EACE,+DAAA;EACA,8DAAA;AACF;AAHA;EAKM,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;AACN;AAfA;EAiBU,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;AACV;AAAU;EAAA;IACE,aAAA;EAGV;AACF;AA5BA;EA8BM,kBAAA;EACA,UAAA;EACA,YAAA;EACA,6CAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,6CAAA;EACA,MAAA;EACA,OAAA;AACN;AAAM;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,6CAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;AAER;AACM;EACI;IACE,iBAAA;EACV;EACQ;IACE,iBAAA;EACV;EACQ;IACE,4CAAA;EACV;EACQ;IACE,gBAAA;EACV;EACQ;;IACE,gBAAA;IACA,6CAAA;EAEV;AACF;AAhFA;EAkFM,kBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACN;AAjGA;EAkGQ,6BAAA;EACA,eAAA;EACA,mBAAA;AAER","sourcesContent":[".welcome__container {\n  --backgroundWhiteClose: url('../../img/vanStaenWhiteClose.jpg');\n  --backgroundWhiteOpen: url('../../img/vanStaenWhiteOpen.jpg');\n\n  .welcome__welcome {  \n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      z-index: 1;\n      width: 100vw;\n      top: 0;\n      left: 0;\n      position: absolute;\n\n      .welcome__openeyes {\n          position: absolute;\n          margin-top: -75px;\n          margin-right: -20px;\n          width: min(450px, 50vw);\n          height: min(150px, 20vh);\n          border: 1px solid transparent;\n          @media all and (max-width: 670px) {\n            bottom: 200px;\n          }\n      }   \n  }\n  \n  .welcome__background {\n      position: absolute;\n      z-index: 0;\n      width: 100vw;\n      background-image: var(--backgroundWhiteClose); \n      background-color: cyan;\n      background-blend-mode: lighten;\n      background-attachment: fixed;\n      background-position: bottom;\n      background-repeat: no-repeat;\n      background-size: cover;\n      transition: background-image .2s ease-in-out;\n      top: 0;\n      left: 0;\n      &:after {\n        content: '';\n        position: absolute;\n        display: block;\n        width: 100vw;\n        height: 100%;\n        z-index: 1;\n        padding-left: 7px;\n        background-image: var(--backgroundWhiteClose); \n        background-color: red;\n        background-blend-mode: lighten;\n        background-size: cover;\n        mix-blend-mode: darken;\n        background-attachment: fixed;\n        background-position: bottom;\n        background-repeat: no-repeat;\n        transition: background-image .2s ease-in-out;\n        //animation: stack 5s cubic-bezier(.46,.29,0,1.24) infinite;\n      } \n      @keyframes stack {\n          0% {\n            margin-left: 15px;\n          }\n          3% {\n            margin-left: -5px;\n          }\n          4% {\n            background-image: var(--backgroundWhiteOpen); \n          }\n          6% {\n            margin-left: 5px;\n          }\n          10% ,100% {\n            margin-left: 5px;\n            background-image: var(--backgroundWhiteClose); \n          }\n        }\n      }\n  .welcome__loader {\n      position: absolute;\n      z-index: 0;\n      width: 100vw;\n      background-color: white;\n      top: 0;\n      left: 0; \n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      color: black;\n      font-size: 14px;\n      font-weight: 300;\n      letter-spacing: 3px;\n      .welcome__imageLoading {\n        color: rgba(33, 33, 33, .25);\n        font-size: 52px;\n        margin-bottom: 20px;\n      }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
